<template>
  <a-modal :title="title" v-model="visible" :width="1000" :footer="null" destroyOnClose>
    <div class="tips">{{ tips }}<span style="margin-left: 15px; color: darkolivegreen; cursor: pointer;" @click="handleDownloadTemplate">{{ $t('下载模板') }}</span></div>
    <div class="uploader">
      <div class="title">{{ $t('上传') }}</div>
      <a-upload :accept="'.xls,.xlsx'" :multiple="false" :customRequest="handleUpload" :showUploadList="false">
        <div class="button">
          <a-icon type="cloud-upload" />
          <span style="margin-left: 10px;">{{ $t('点击此处上传') }}</span>
        </div>
      </a-upload>
    </div>
  </a-modal>
</template>
<script>
import { importDictData, downloadDictTemplate } from '@/api/system/dict'
import { saveBlob } from '@/api/file/file'

export default {
  data() {
    return {
      appData: {},
      visible: false,
    }
  },
  computed: {
    title() {
      return `${this.appData.name || ''}${this.$t('导入字典')}`
    },
    tips() {
      return this.$t('请按照模板要求，导入字典信息。')
    }
  },
  methods: {
    show(data) {
      this.appData = { ...data }
      this.visible = true
    },
    handleDownloadTemplate() {
      downloadDictTemplate().then(res => {
        saveBlob(res, '字典模板.xlsx')
      })
    },
    handleUpload(data) {
      const file = data.file
      this.uploading = true
      importDictData(file, { appId: this.appData.id }).then(res => {
        if (res.code === 0) {
          this.$message.success(this.$t('保存成功'))
          this.$emit('ok')
          data.onSuccess(data.file.name)
          this.visible = false
        } else {
          this.$message.error(res.message || '保存失败')
          data.onError(res.msg)
        }
      }).catch(() => {
        this.$message.error(this.$t('保存失败'))
      }).finally(() => {
        this.uploading = false
      })
    }
  },
}
</script>
<style lang="less" scoped>
.tips {
  border-radius: 4px;
  height: 36px;
  font-size: 14px;
  color: #333333;
  background-color: #d0dec8;
  margin: 0 0 20px 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 10px;
}

.uploader {
  display: flex;
  flex-direction: row;
  align-items: center;

  .title {
    background-color: #f3f5f8;
    color: #333333;
    padding: 8px 25px;
    border-radius: 4px;
  }

  .button {
    cursor: pointer;
    padding: 8px 15px;
    border-radius: 4px;
    border: 1px dashed #dddddd;
    margin-left: 10px;
  }

}
</style>